var render, staticRenderFns
import script from "./GradientBtn.vue?vue&type=script&lang=ts&"
export * from "./GradientBtn.vue?vue&type=script&lang=ts&"
import style0 from "./GradientBtn.vue?vue&type=style&index=0&id=4a6cbbc5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6cbbc5",
  null
  
)

export default component.exports